<form [formGroup]="form" (ngSubmit)="save()">

    <div class="flex items-center" mat-dialog-title>
        <mat-icon svgIcon="mat:table_chart" class="text-primary mr-4"></mat-icon>
        <h2 class="headline m-0 flex-auto dialog-title-large">
            <span *ngIf="isCreateMode">
                {{ dialogTitle | translate }}
                <span *ngIf="data.parentNode" class="text-secondary" style="font-size: 0.7em; font-weight: 400;">
                    — Padre: {{ data.parentNode.code }} - {{ data.parentNode.name }}
                </span>
            </span>
            <span *ngIf="isUpdateMode" class="text-primary font-semibold">
                {{ currentProjectName || "ACTIONS.EDITAR_NODO" | translate }}
            </span>
        </h2>
        
        <!-- Botón para volver al padre (solo en nivel > 0) -->
        <button 
            *ngIf="isUpdateMode && hasParent" 
            (click)="goToParent()" 
            mat-icon-button 
            type="button"
            [matTooltip]="'ACTIONS.VOLVER_AL_PADRE' | translate"
            class="mr-2">
            <mat-icon svgIcon="mat:arrow_upward"></mat-icon>
        </button>
        
        <button (click)="cancel()" mat-icon-button type="button">
            <mat-icon svgIcon="mat:close"></mat-icon>
        </button>
    </div>

    <mat-divider class="-mx-6 text-border"></mat-divider>

    <mat-dialog-content class="flex flex-col compact-dialog-content">
        
        <!-- Tabs para separar detalle y hijos -->
        <mat-tab-group [(selectedIndex)]="selectedTabIndex" class="project-tabs">
            <!-- Tab 1: Detalle del Proyecto -->
            <mat-tab label="Detalle">
        <!-- Formulario compacto con diseño de dos columnas -->
        <div class="form-container-compact">
            
            <!-- Info del padre y selector de proyecto existente (solo en modo creación con padre) -->
            <div *ngIf="isCreateMode && data.parentNode" class="form-row-compact" style="margin-bottom: 16px; padding: 12px; background-color: #e3f2fd; border-radius: 4px; border-left: 4px solid #1976d2;">
                <div class="form-field-compact flex-2">
                    <label class="form-label-compact" style="font-weight: 600; color: #1976d2; margin-bottom: 4px; display: block;">
                        <mat-icon svgIcon="mat:account_tree" style="vertical-align: middle; margin-right: 4px; font-size: 18px; width: 18px; height: 18px;"></mat-icon>
                        Proyecto padre: {{ data.parentNode.code }} - {{ data.parentNode.name }}
                    </label>
                    
                    <div style="margin-top: 12px; padding-top: 12px; border-top: 1px solid #bbdefb;">
                        <label class="form-label-compact" style="font-weight: 500; color: #666; font-size: 12px;">
                            O seleccionar un proyecto existente sin padre para asignarlo como hijo (opcional):
                        </label>
                        <mat-form-field appearance="outline" class="form-field-input-compact">
                            <input 
                                type="text" 
                                matInput 
                                [formControl]="existingProjectInputControl"
                                [matAutocomplete]="autoProject"
                                placeholder="Buscar proyecto existente (opcional)">
                            <mat-autocomplete 
                                #autoProject="matAutocomplete" 
                                [displayWith]="displayProjectFn"
                                (optionSelected)="onProjectAutocompleteSelected($event)">
                                <mat-option *ngFor="let project of filteredProjectsWithoutParent | async" [value]="project">
                                    {{ project.code }} - {{ project.name }}
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                        <div *ngIf="selectedExistingProject" style="margin-top: 8px; padding: 8px; background-color: #fff; border-radius: 4px; display: flex; align-items: center; justify-content: space-between;">
                            <span style="font-size: 12px; color: #1976d2;">
                                <mat-icon svgIcon="mat:check_circle" style="vertical-align: middle; margin-right: 4px; font-size: 16px; width: 16px; height: 16px;"></mat-icon>
                                Proyecto seleccionado: {{ selectedExistingProject.code }} - {{ selectedExistingProject.name }}
                            </span>
                            <button mat-icon-button type="button" (click)="clearExistingProjectSelection()" style="width: 24px; height: 24px; line-height: 24px;">
                                <mat-icon svgIcon="mat:close" style="font-size: 18px; width: 18px; height: 18px;"></mat-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            
            <!-- Primera fila: Proyecto (ancho completo) -->
            <div class="form-row-compact">
                <div class="form-field-compact flex-2">
                    <label class="form-label-compact">Proyecto:</label>
                    <mat-form-field appearance="outline" class="form-field-input-compact">
                        <input matInput formControlName="proyecto" placeholder="Nombre del proyecto" [readonly]="selectedExistingProject !== null">
                        <mat-error *ngIf="form.get('proyecto')?.hasError('required')">
                            Requerido
                        </mat-error>
                        <mat-error *ngIf="form.get('proyecto')?.hasError('minlength')">
                            Mínimo 2 caracteres
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <!-- Segunda fila: Tipo y Código -->
            <div class="form-row-compact">
                <div class="form-field-compact" style="flex: 0 0 180px; min-width: 150px; max-width: 200px;">
                    <label class="form-label-compact">Tipo:</label>
                    <mat-form-field appearance="outline" class="form-field-input-compact">
                        <mat-select formControlName="tipo">
                            <mat-option value="">Seleccionar...</mat-option>
                            <mat-option *ngFor="let type of projectTypes" [value]="type.id">
                                {{ type.name }}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="form.get('tipo')?.hasError('required')">
                            Requerido
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="form-field-compact" style="flex: 1 1 auto; min-width: 0; max-width: 100%; overflow: visible;">
                    <label class="form-label-compact">Código:</label>
                    <!-- Si es hijo -->
                    <div *ngIf="hasInheritedCode" style="width: 100%; max-width: 100%;">
                        <!-- Para tipo proyecto: mostrar prefijo, input (deshabilitado) y lista seleccionable -->
                        <div *ngIf="showLevelsDropdown" class="code-input-container" style="display: flex; align-items: center; gap: 4px; flex-wrap: nowrap; width: 100%; max-width: 100%;">
                            <!-- Prefijo del código del padre -->
                            <span class="code-prefix" style="flex-shrink: 0;">{{ parentCodePrefix }}</span>
                            
                            <!-- Input: Codigo - editable para tipo proyecto -->
                            <mat-form-field appearance="outline" class="form-field-input-compact" style="flex: 1 1 auto; min-width: 150px;">
                            <input matInput 
                                   formControlName="codigo" 
                                       placeholder="Código">
                            <mat-error *ngIf="form.get('codigo')?.hasError('required')">
                                Requerido
                            </mat-error>
                            </mat-form-field>
                            
                            <!-- Lista seleccionable - solo para tipo proyecto -->
                            <mat-form-field appearance="outline" class="form-field-input-compact" style="flex: 1 1 auto; min-width: 150px;">
                                <mat-select formControlName="codigoLista" placeholder="">
                                    <mat-option value="">Seleccionar código...</mat-option>
                                    <mat-option *ngFor="let codeOption of availableCodes" [value]="codeOption.code">
                                        {{ codeOption.code }} - {{ codeOption.description }}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="form.get('codigoLista')?.hasError('required')">
                                    Requerido
                                </mat-error>
                            </mat-form-field>
                        </div>
                        
                        <!-- Para otros tipos: mostrar prefijo e input de código -->
                        <div *ngIf="!showLevelsDropdown" class="code-input-container" style="display: flex; align-items: center; gap: 4px; flex-wrap: nowrap; width: 100%; max-width: 100%;">
                            <!-- Prefijo del código del padre -->
                            <span class="code-prefix" style="flex-shrink: 0;">{{ parentCodePrefix }}</span>
                            
                            <!-- Input: Codigo - para tipos no proyecto -->
                            <mat-form-field appearance="outline" class="form-field-input-compact" style="flex: 1 1 auto; min-width: 150px;">
                                <input matInput 
                                       formControlName="codigo" 
                                       placeholder="Código">
                                <mat-error *ngIf="form.get('codigo')?.hasError('required')">
                                    Requerido
                            </mat-error>
                        </mat-form-field>
                        </div>
                        
                        <!-- Label que muestra el código completo para tipo proyecto -->
                        <div *ngIf="showLevelsDropdown && hasInheritedCode && fullProjectCode" class="full-code-label" style="margin-top: 8px; padding: 8px; background-color: #f5f5f5; border-radius: 4px; border: 1px solid #e0e0e0;">
                            <strong>Código:</strong> <span style="font-family: monospace; color: #1976d2;">{{ fullProjectCode }}</span>
                        </div>
                    </div>
                    
                    <!-- Input completo para nodos raíz (sin prefijo heredado o level = 0) -->
                    <mat-form-field *ngIf="!hasInheritedCode || data.level === 0" appearance="outline" class="form-field-input-compact">
                        <input matInput 
                               formControlName="codigo" 
                               placeholder="Código">
                        <mat-error *ngIf="form.get('codigo')?.hasError('required')">
                            Requerido
                        </mat-error>
                        <mat-error *ngIf="form.get('codigo')?.hasError('minlength')">
                            Mínimo 1 carácter
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <!-- Tercera fila: Toggles de configuración (misma línea) -->
            <div class="form-row-compact toggle-row">
                <div class="toggle-item">
                    <mat-slide-toggle formControlName="aprobado" color="primary">
                        Aprobado
                    </mat-slide-toggle>
                </div>
                <div class="toggle-item">
                    <mat-slide-toggle formControlName="requiereObservacion" color="primary">
                        Requiere Observación
                    </mat-slide-toggle>
                </div>
                <div class="toggle-item">
                    <mat-slide-toggle formControlName="horasNormales" color="primary">
                        Horas normales
                    </mat-slide-toggle>
                </div>
                <div class="toggle-item">
                    <mat-slide-toggle formControlName="activo" color="primary">
                        {{ "GRIDS.ACTIVO" | translate }}
                    </mat-slide-toggle>
                </div>
                <div class="toggle-item">
                    <mat-slide-toggle formControlName="visible" color="accent">
                        Visible
                    </mat-slide-toggle>
                </div>
                <div class="toggle-item">
                    <mat-slide-toggle formControlName="horasExtras" color="primary">
                        Horas extras
                    </mat-slide-toggle>
                </div>
            </div>

            <!-- Cuarta fila: Fecha Inicio, Fecha Termino y Fecha Estimada de Termino -->
            <div class="form-row-compact">
                <div class="form-field-compact">
                    <label class="form-label-compact">Fecha Inicio:</label>
                    <mat-form-field appearance="outline" class="form-field-input-compact">
                        <input matInput [matDatepicker]="pickerInicio" formControlName="fechaInicio" placeholder="DD/MM/YYYY">
                        <mat-datepicker-toggle matSuffix [for]="pickerInicio"></mat-datepicker-toggle>
                        <mat-datepicker #pickerInicio></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="form-field-compact">
                    <label class="form-label-compact">Fecha Termino:</label>
                    <mat-form-field appearance="outline" class="form-field-input-compact">
                        <input matInput [matDatepicker]="pickerTermino" formControlName="fechaTermino" placeholder="DD/MM/YYYY">
                        <mat-datepicker-toggle matSuffix [for]="pickerTermino"></mat-datepicker-toggle>
                        <mat-datepicker #pickerTermino></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="form-field-compact">
                    <label class="form-label-compact">Fecha Estimada de Termino:</label>
                    <mat-form-field appearance="outline" class="form-field-input-compact">
                        <input matInput [matDatepicker]="pickerEstimadaTermino" formControlName="fechaEstimadaTermino" placeholder="DD/MM/YYYY">
                        <mat-datepicker-toggle matSuffix [for]="pickerEstimadaTermino"></mat-datepicker-toggle>
                        <mat-datepicker #pickerEstimadaTermino></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>

            <!-- Quinta fila: Jefe de Proyecto, Control de Proyecto y Control Documental -->
            <div class="form-row-compact">
                <div class="form-field-compact">
                    <label class="form-label-compact">Jefe de Proyecto:</label>
                    <mat-form-field appearance="outline" class="form-field-input-compact">
                        <input type="text"
                               matInput
                               formControlName="id_jefeProyecto"
                               placeholder="Seleccionar usuario..."
                               [matAutocomplete]="autoJefeProyecto">
                        <mat-autocomplete #autoJefeProyecto="matAutocomplete" 
                                          [displayWith]="displayUserFn">
                            <mat-option *ngFor="let option of filteredJefeProyectoList | async" [value]="option">
                                {{ option.name }}
                            </mat-option>
                        </mat-autocomplete>
                        <button type="button" 
                                *ngIf="form.get('id_jefeProyecto')?.value" 
                                matSuffix 
                                mat-icon-button
                                aria-label="Clear" 
                                (click)="resetUser('id_jefeProyecto')">
                            <mat-icon>close</mat-icon>
                        </button>
                    </mat-form-field>
                </div>
                <div class="form-field-compact">
                    <label class="form-label-compact">Control de Proyecto:</label>
                    <mat-form-field appearance="outline" class="form-field-input-compact">
                        <input type="text"
                               matInput
                               formControlName="id_controlProyecto"
                               placeholder="Seleccionar usuario..."
                               [matAutocomplete]="autoControlProyecto">
                        <mat-autocomplete #autoControlProyecto="matAutocomplete" 
                                          [displayWith]="displayUserFn">
                            <mat-option *ngFor="let option of filteredControlProyectoList | async" [value]="option">
                                {{ option.name }}
                            </mat-option>
                        </mat-autocomplete>
                        <button type="button" 
                                *ngIf="form.get('id_controlProyecto')?.value" 
                                matSuffix 
                                mat-icon-button
                                aria-label="Clear" 
                                (click)="resetUser('id_controlProyecto')">
                            <mat-icon>close</mat-icon>
                        </button>
                    </mat-form-field>
                </div>
                <div class="form-field-compact">
                    <label class="form-label-compact">Control Documental:</label>
                    <mat-form-field appearance="outline" class="form-field-input-compact">
                        <input type="text"
                               matInput
                               formControlName="id_controlDocumental"
                               placeholder="Seleccionar usuario..."
                               [matAutocomplete]="autoControlDocumental">
                        <mat-autocomplete #autoControlDocumental="matAutocomplete" 
                                          [displayWith]="displayUserFn">
                            <mat-option *ngFor="let option of filteredControlDocumentalList | async" [value]="option">
                                {{ option.name }}
                            </mat-option>
                        </mat-autocomplete>
                        <button type="button" 
                                *ngIf="form.get('id_controlDocumental')?.value" 
                                matSuffix 
                                mat-icon-button
                                aria-label="Clear" 
                                (click)="resetUser('id_controlDocumental')">
                            <mat-icon>close</mat-icon>
                        </button>
                    </mat-form-field>
                </div>
            </div>

            <!-- Sexta fila: Moneda y HH Estimadas -->
            <div class="form-row-compact">
                <div class="form-field-compact">
                    <label class="form-label-compact">{{ "GRIDS.MONEDA" | translate }}:</label>
                    <mat-form-field appearance="outline" class="form-field-input-compact">
                        <mat-select formControlName="moneda">
                            <mat-option value="">Seleccionar...</mat-option>
                            <mat-option *ngFor="let currency of projectCurrencies" [value]="currency.id">
                                {{ currency.code }} - {{ currency.name }} ({{ currency.symbol }})
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="form.get('moneda')?.hasError('required')">
                            Requerido
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="form-field-compact">
                    <label class="form-label-compact">HH Estimadas:</label>
                    <mat-form-field appearance="outline" class="form-field-input-compact">
                        <input matInput type="number" formControlName="HHEstimadas" placeholder="0">
                    </mat-form-field>
                </div>
            </div>

            <!-- Octava fila: Cliente, Origen y PEP -->
            <div class="form-row-compact">
                <div class="form-field-compact">
                    <label class="form-label-compact">Cliente:</label>
                    <mat-form-field appearance="outline" class="form-field-input-compact">
                        <mat-select formControlName="id_cliente">
                            <mat-option value="">Seleccionar...</mat-option>
                            <mat-option *ngFor="let client of projectClients" [value]="client.id">
                                {{ client.name }}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="form.get('id_cliente')?.hasError('required')">
                            Requerido
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="form-field-compact">
                    <label class="form-label-compact">Origen:</label>
                    <mat-form-field appearance="outline" class="form-field-input-compact">
                        <mat-select formControlName="origen">
                            <mat-option value="">Seleccionar...</mat-option>
                            <mat-option *ngFor="let origin of projectOrigins" [value]="origin.id">
                                {{ origin.name }}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="form.get('origen')?.hasError('required')">
                            Requerido
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="form-field-compact">
                    <label class="form-label-compact">PEP:</label>
                    <mat-form-field appearance="outline" class="form-field-input-compact">
                        <input matInput formControlName="pep" placeholder="PEP">
                    </mat-form-field>
                </div>
            </div>

                </div>
            </mat-tab>
            
            <!-- Tab 2: Padre/Hijos (solo en modo edición) -->
            <mat-tab label="Padre/Hijos" *ngIf="isUpdateMode">
                <!-- Selector de proyecto padre -->
                <div class="parent-selector-container" style="margin-bottom: 16px; padding: 12px; background-color: #f5f5f5; border-radius: 4px;">
                    <mat-form-field appearance="outline" style="width: 100%;">
                        <mat-label>Proyecto padre</mat-label>
                        <input matInput
                               [formControl]="parentAutocompleteControl"
                               [matAutocomplete]="autoParent"
                               placeholder="Buscar proyecto padre...">
                        <mat-autocomplete #autoParent="matAutocomplete"
                                          [displayWith]="displayParentFn"
                                          (optionSelected)="onParentSelected($event)">
                            <mat-option *ngFor="let project of filteredParentList | async" [value]="project">
                                {{ project.code }} - {{ project.name }}
                            </mat-option>
                        </mat-autocomplete>
                        <mat-icon matPrefix svgIcon="mat:account_tree"></mat-icon>
                        <button mat-icon-button
                                matSuffix
                                *ngIf="parentAutocompleteControl.value"
                                (click)="clearParentSelection()"
                                aria-label="Quitar padre">
                            <mat-icon svgIcon="mat:close"></mat-icon>
                        </button>
                    </mat-form-field>
                    <p class="caption m-0 opacity-70" style="margin-top: 4px;">
                        Seleccione el proyecto padre. Si deja vacío, este proyecto será raíz.
                    </p>
                </div>

                <!-- Filtro para hijos -->
                <div class="children-filter-container" style="margin-bottom: 16px; padding: 12px;">
                    <mat-form-field appearance="outline" style="width: 100%;">
                        <mat-label>Filtrar por código o descripción</mat-label>
                        <input matInput 
                               [formControl]="childrenFilterControl"
                               (input)="onChildrenFilterChange()"
                               placeholder="Buscar por código, nombre o descripción...">
                        <mat-icon matPrefix svgIcon="mat:search"></mat-icon>
                        <button mat-icon-button 
                                matSuffix 
                                *ngIf="childrenFilterControl.value" 
                                (click)="childrenFilterControl.setValue('')"
                                aria-label="Limpiar filtro">
                            <mat-icon svgIcon="mat:clear"></mat-icon>
                        </button>
                    </mat-form-field>
        </div>

        <!-- Grilla de hijos (solo en modo edición cuando hay hijos) -->
                <div *ngIf="hasSiblings" class="siblings-section-compact">
            <h3 class="siblings-title-compact">
                <mat-icon svgIcon="mat:account_tree" class="siblings-icon-compact"></mat-icon>
                {{ "GRIDS.HIJOS" | translate }}
            </h3>
            
            <div class="siblings-table-container-compact">
                <div class="siblings-table-wrapper">
                    <table [dataSource]="siblingsDataSource" class="w-full" mat-table matSort #siblingsSort="matSort">
                        
                        <!-- Columnas de texto -->
                        <ng-container *ngFor="let column of siblingsColumns; trackBy: trackByProperty">
                            <ng-container *ngIf="column.type === 'text' && column.visible" 
                                          [matColumnDef]="column.property">
                                <th *matHeaderCellDef class="siblings-header-compact" mat-header-cell mat-sort-header>
                                    {{ column.label | translate }}
                                </th>
                                <td *matCellDef="let row" 
                                    class="siblings-cell-compact"
                                    [ngClass]="{'current-node': isCurrentNode(row.id)}"
                                    [class]="(column.cssClasses ? column.cssClasses.join(' ') : '')"
                                    mat-cell>
                                    {{ row[column.property] || '-' }}
                                </td>
                            </ng-container>
                            
                            <!-- Columnas de imagen (iconos) -->
                            <ng-container *ngIf="column.type === 'image' && column.visible" 
                                          [matColumnDef]="column.property">
                                <th *matHeaderCellDef class="siblings-header-compact" mat-header-cell mat-sort-header>
                                    {{ column.label | translate }}
                                </th>
                                <td *matCellDef="let row" 
                                    class="siblings-cell-compact"
                                    [ngClass]="{'current-node': isCurrentNode(row.id)}"
                                    mat-cell>
                                    <mat-icon *ngIf="row[column.property]" svgIcon="mat:check" class="text-green-600"></mat-icon>
                                    <mat-icon *ngIf="!row[column.property]" svgIcon="mat:clear" class="text-red-600"></mat-icon>
                                </td>
                            </ng-container>
                        </ng-container>

                        <tr *matHeaderRowDef="visibleSiblingsColumns" mat-header-row></tr>
                        <tr *matRowDef="let row; columns: visibleSiblingsColumns" 
                            (click)="editSibling(row)"
                            [class.current-node-row]="isCurrentNode(row.id)"
                            class="siblings-row-compact cursor-pointer"
                            mat-row></tr>
                    </table>
                </div>

                <!-- Paginador compacto -->
                <mat-paginator 
                    #siblingsPaginator="matPaginator"
                    [pageSize]="5"
                    [pageSizeOptions]="[5, 10, 20]"
                    showFirstLastButtons
                    class="siblings-paginator-compact">
                </mat-paginator>
                
                <!-- Botón para agregar hijo (cuando hay hijos) -->
                <div style="margin-top: 16px; display: flex; justify-content: flex-end;">
                    <button 
                        mat-raised-button 
                        color="primary" 
                        (click)="createSibling()"
                        class="create-sibling-button">
                        <mat-icon svgIcon="mat:add"></mat-icon>
                        {{ "ACTIONS.AGREGAR_HIJO" | translate }}
                    </button>
                </div>
            </div>
        </div>

        <!-- Botón para crear hijo cuando no hay hijos (solo en modo edición) -->
                <div *ngIf="!hasSiblings" class="siblings-section-compact">
            <h3 class="siblings-title-compact">
                <mat-icon svgIcon="mat:account_tree" class="siblings-icon-compact"></mat-icon>
                {{ "GRIDS.HIJOS" | translate }}
            </h3>
            
            <div class="no-siblings-container">
                <p class="no-siblings-message">{{ "MESSAGES.NO_CHILDREN" | translate }}</p>
                <button 
                    mat-raised-button 
                    color="primary" 
                    (click)="createSibling()"
                    class="create-sibling-button">
                    <mat-icon svgIcon="mat:add"></mat-icon>
                    {{ "ACTIONS.AGREGAR_HIJO" | translate }}
                </button>
            </div>
        </div>
            </mat-tab>
        </mat-tab-group>

    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-button type="button" (click)="cancel()" [disabled]="isLoading">
            {{ "ACTIONS.CANCELAR" | translate }}
        </button>
        
        <button 
            mat-raised-button 
            color="primary" 
            type="submit" 
            [disabled]="form.invalid || isLoading">
            
            <mat-spinner *ngIf="isLoading" diameter="20" class="mr-2"></mat-spinner>
            <mat-icon *ngIf="!isLoading" [svgIcon]="isCreateMode ? 'mat:add' : 'mat:save'" class="mr-2"></mat-icon>
            
            {{ (isCreateMode ? "ACTIONS.CREAR" : "ACTIONS.ACTUALIZAR") | translate }}
        </button>
    </mat-dialog-actions>

</form>
